const gtmConfig = {
  id: 'GTM-KLBCHGJ',
};
export default gtmConfig;
